import { useContext, useState } from 'react'

import { InputAdornment } from '@material-ui/core'
import { AttachMoney } from '@material-ui/icons'
import { EditContext } from 'Components/Hooks/ContextEdit'
import CustomButton from 'Components/UI/Atoms/CustomButton'
import ContentWithSubTabs from 'Components/UI/Molecules/ContentWithSubTabs'
import InputsWithValidate from 'Components/UI/Molecules/InputsWithValidate'
import { RECEIPT_STATE } from 'Constants'
import { Form, Formik } from 'formik'
import * as yup from 'yup'

const HomeContent = (props) => {
  const {
    data,
    originalData,
    setData,
    formikRef,
    permissions,
    canGenerateComprobante,
    generatingComprobante,
    handleGenerateComprobante,
  } = props

  const [edit] = useContext(EditContext)
  const [tab, setTab] = useState(0)

  const handleChange = (name, value) => {
    setData((prevData) => ({
      ...prevData,
      paymentOrder: {
        ...prevData.paymentOrder,
        [name]: value,
      },
    }))
  }

  const validationSchema = yup.object().shape({
    origen: yup.string().trim().required('Campo obligatorio'),
    fecha_creacion: yup.string().trim().required('Campo obligatorio'),
    usuario: yup.string().trim(),
    nro_comprobante: yup.string().trim().required('Campo obligatorio'),
    modalidad: yup.string().trim().required('Campo obligatorio'),
    importe: yup.string().trim().required('Campo obligatorio'),
    estado: yup.string().trim().required('Campo obligatorio'),
    observacion: yup.string().trim(),
    cliente_id: yup.string().trim(),
    cuit: yup.string().trim(),
    razon_social: yup.string().trim().required('Campo obligatorio'),
    provincia: yup.string().trim(),
    localidad: yup.string().trim(),
    direccion: yup.string().trim(),
  })

  const infoGeneralFields = (values, handleChange, edit, permissions, originalData) => [
    {
      class: 'textfield',
      name: 'origen',
      label: 'Origen',
      value: values.origen,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'datepicker',
      name: 'fecha_creacion',
      label: 'Fecha de creación',
      format: 'dd-MM-yyyy',
      value: values.fecha_creacion,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'usuario',
      label: 'Usuario',
      value: values.usuario,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'nro_comprobante',
      label: 'N° comprobante',
      value: values.nro_comprobante,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'modalidad',
      label: 'Modalidad',
      value: values.modalidad,
      disabled: true,
      sm: 4,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'importe',
      label: 'Importe',
      value: values.importe,
      disabled: true,
      sm: 4,
      xs: 12,
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
    },
    {
      class: 'autocomplete',
      name: 'estado',
      label: 'Estado',
      options: RECEIPT_STATE.filter((option) => option.label !== 'Todos'),
      optionValue: 'label',
      optionLabel: `options["label"]`,
      value: values.estado,
      disabled:
        !permissions.changeState || !edit || originalData?.paymentOrder?.estado === 'Borrador',
      sm: 4,
      xs: 12,
      onChange: (e) => handleChange('estado', e.label),
    },
    {
      class: 'textfield',
      name: 'observacion',
      label: 'Observación',
      value: values.observacion,
      disabled: !edit,
      sm: 12,
      xs: 12,
      multiline: true,
      rows: 4,

      onChange: (e) => {
        handleChange('observacion', e.target.value)
      },
    },
  ]

  const clientFields = (values) => [
    {
      class: 'textfield',
      name: 'cliente_id',
      label: 'N° cliente',
      value: values.cliente_id,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'cuit',
      label: 'CUIT/CUIL/DNI',
      value: values.cuit,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'razon_social',
      label: 'Razón social',
      value: values.razon_social,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'provincia',
      label: 'Provincia',
      value: values.provincia,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'localidad',
      label: 'Localidad',
      value: values.localidad,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'direccion',
      label: 'Dirección',
      value: values.direccion,
      disabled: true,
      sm: 6,
      xs: 12,
    },
  ]

  const verticalTabs = [
    {
      id: 0,
      title: 'Información general',
    },
    {
      id: 1,
      title: 'Datos de cliente',
    },
  ]

  return (
    <Formik
      innerRef={formikRef}
      enableReinitialize
      initialValues={{
        origen: data?.paymentOrder?.origen || '',
        fecha_creacion: data?.paymentOrder?.fecha || '',
        usuario: data?.paymentOrder?.usuario || '',
        nro_comprobante: data?.paymentOrder?.comprobante || '',
        modalidad: data?.paymentOrder?.modalidad || '',
        importe: data?.paymentOrder?.total || '',
        estado: data?.paymentOrder?.estado || '',
        observacion: data?.paymentOrder?.observacion || '',
        cliente_id: data?.cliente?.id || '',
        cuit: data?.cliente?.cuit || '',
        razon_social: data?.cliente?.nombre || '',
        provincia: data?.cliente?.provincia || '',
        localidad: data?.cliente?.localidad || '',
        direccion: data?.cliente?.domicilio || '',
      }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        const newData = {
          ...data,
          paymentOrder: {
            ...(data?.paymentOrder || {}),
            origen: values.origen,
            fecha: values.fecha_creacion,
            usuario: values.usuario,
            comprobante: values.nro_comprobante,
            modalidad: values.modalidad,
            total: values.importe,
            estado: values.estado,
            observacion: values.observacion,
          },
          cliente: {
            ...(data?.cliente || {}),
            id: values.cliente_id,
            cuit: values.cuit,
            nombre: values.razon_social,
            provincia: values.provincia,
            localidad: values.localidad,
            domicilio: values.direccion,
          },
        }
        setData(newData)
        // No llamamos setLoading aquí, el submit real lo maneja el padre
      }}
    >
      {({ values, setFieldValue, isSubmitting }) => (
        <Form>
          <div>
            <ContentWithSubTabs
              listVerticalTabs={verticalTabs}
              value={tab}
              setValue={setTab}
              children={
                <div style={{ margin: '20px' }}>
                  {tab === 0 ? (
                    <>
                      <InputsWithValidate
                        fields={infoGeneralFields(
                          values,
                          handleChange,
                          edit,
                          permissions,
                          originalData
                        )}
                        spacing={2}
                        isSubmitting={isSubmitting}
                      />
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          marginTop: '46px',
                        }}
                      >
                        <CustomButton
                          buttonEnd
                          text="Generar orden de pago"
                          color="primary"
                          onClick={handleGenerateComprobante}
                          disabled={!canGenerateComprobante || generatingComprobante}
                        />
                      </div>
                    </>
                  ) : (
                    <InputsWithValidate
                      fields={clientFields(values)}
                      spacing={2}
                      setFieldValue={setFieldValue}
                      isSubmitting={isSubmitting}
                    />
                  )}
                </div>
              }
            />
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default HomeContent
